<onyx-information-heading [identifierColor]="identifierColor()">
  {{ 'labels.driverNote' | translate }}
</onyx-information-heading>

@if (note(); as note) {
  <div class="note">
    <p class="content" [class.f-muted]="!note">
      {{ note }}
    </p>
  </div>
} @else {
  <span class="f-muted">
    {{ 'labels.missingNote' | translate }}
  </span>
}
